import { Injectable } from '@angular/core';
import { Action, Selector, State, Store, type StateContext } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '../../internal';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SlideViewerStateModel {
}

@State<SlideViewerStateModel>({
  name: 'slideViewer',
  defaults: {
  }
})
@Injectable()
export class SlideViewerState {
  constructor(public store: Store) {
  }

  //<editor-fold desc="Selectors">

  @Selector([FlatStates.NodeEntityState.typedRouteElements$])
  static slideUrlByNode$(typedRouteElements: { [id: string]: FlatModels.NodeEntityModels.RouteElement }) {
    return (slideNode: FlatModels.NodeEntityModels.SlideNode) => {
      if (slideNode && slideNode.parentId) {
        const routeElement = typedRouteElements[slideNode.parentId];
        if (routeElement) {
          return ['/' + routeElement.path + '/' + slideNode.route];
        }
      }
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.parent_node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatStates.SlideViewerFacade.slideUrlByNode$"
      );
    }
  }

  //</editor-fold>

  //<editor-fold desc="Actions">

  @Action(FlatActions.SlideViewerActions.GoToSlideByNode)
  goToSlideByNode({dispatch}: StateContext<SlideViewerStateModel>,
                  {slideNode}: FlatActions.SlideViewerActions.GoToSlideByNode) {
    if (!slideNode) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.node_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatStates.SlideViewerFacade.goToSlideByNode"
      );
    }

    if (slideNode.parentId) {
      const typedRouteElements = this.store.selectSnapshot(FlatStates.NodeEntityState.typedRouteElements$);
      const routeElement = typedRouteElements[slideNode.parentId];
      if (routeElement) {
        // Navigate to first slide
        return dispatch(new Navigate([routeElement.path + '/' + slideNode.route]));
      }
    }
    
    throw new FlatModels.ErrorControlModels.MedsurfError(
      'notification.parent_node_not_found',
      FlatModels.ErrorControlModels.ErrorLevel.enum.error,
      FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
      "LIBS.FlatStates.SlideViewerFacade.goToSlideByNode"
    );
  }

  @Action(FlatActions.SlideViewerActions.GoToSlideByIndex)
  goToSlideByIndex({dispatch}: StateContext<SlideViewerStateModel>,
                   {index}: FlatActions.SlideViewerActions.GoToSlideByIndex) {
    const selectedSlideNodes = this.store.selectSnapshot(FlatStates.NodeEntityState.currentSelectedSlideNodes$);
    if (selectedSlideNodes.length > 0) {
      const selectedSlideNode = selectedSlideNodes.find(sn => sn.position === index);
      if (selectedSlideNode && selectedSlideNode.parentId) {
        const typedRouteElements = this.store.selectSnapshot(FlatStates.NodeEntityState.typedRouteElements$);
        const routeElement = typedRouteElements[selectedSlideNode.parentId];
        if (routeElement) {
          // Navigate to first slide
          dispatch(new Navigate([routeElement.path + '/' + selectedSlideNode.route]));
        } else {
          throw new FlatModels.ErrorControlModels.MedsurfError(
            'notification.parent_node_not_found',
            FlatModels.ErrorControlModels.ErrorLevel.enum.error,
            FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
            "LIBS.FlatStates.SlideViewerFacade.goToSlideByIndex"
          );
        }
      } else {
        throw new FlatModels.ErrorControlModels.MedsurfError(
          'notification.node_not_found',
          FlatModels.ErrorControlModels.ErrorLevel.enum.error,
          FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
          "LIBS.FlatStates.SlideViewerFacade.goToSlideByIndex"
        );
      }
    } else {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.no_slides_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatStates.SlideViewerFacade.goToSlideByIndex"
      );
    }
  }

  //</editor-fold>
}
